import * as THREE from "three";

// Global override for Raycaster
const originalIntersectObjects = THREE.Raycaster.prototype.intersectObjects;

THREE.Raycaster.prototype.intersectObjects = function (
  objects,
  recursive = false
) {
  const filteredObjects = objects.filter((obj) => !obj.layers.test(20)); // Skip layer 20
  return originalIntersectObjects.call(this, filteredObjects, recursive);
};

/**
 * A custom Raycaster class that extends THREE.Raycaster.
 * @extends {THREE.Raycaster}
 * @category Experience
 * @subcategory Utils
 */
class Raycaster extends THREE.Raycaster {
  /**
   * Creates an instance of Raycaster.
   * @param {Object} experience - The experience object containing references to the scene, camera, and sizes.
   */
  constructor(experience) {
    super();
    this.experience = experience;
    this.scene = experience.scene;
    this.camera = experience.camera.instance;
    this.sizes = experience.sizes;
    this.mouse = new THREE.Vector2();

    this.registerEventListeners();
  }

  cleanup() {
    window.removeEventListener("mousemove", this.onMouseMove);
    this.mouse.set(0, 0); // Reset mouse vector
    this.scene = null;
    this.camera = null;
    this.sizes = null;
}

  /**
   * Registers event listeners for raycasting, such as mouse movement.
   */
  registerEventListeners() {
    this.onMouseMove();
  }

  /**
   * Sets up a mousemove event listener to update the raycaster's mouse coordinates.
   */
  onMouseMove() {
    window.addEventListener("mousemove", (event) => {
      this.mouse.x = (event.clientX / this.sizes.reSize.width) * 2 - 1;
      this.mouse.y = -(event.clientY / this.sizes.reSize.height) * 2 + 1;

      this.setFromCamera(this.mouse, this.camera);
    });
  }

  /**
   * Intersects an array of objects and returns intersection results.
   * @param {THREE.Object3D[]} objects - The array of objects to check for intersections.
   * @returns {THREE.Intersection[]} An array of intersection results.
   */
  intersectObjects(objects) {
    return super.intersectObjects(objects);
  }

  /**
   * Gets the intersection point on a specific object.
   * @param {THREE.Object3D} object - The object to check for intersection.
   * @returns {THREE.Vector3|null} The intersection point, or null if no intersection occurred.
   */
  getIntersectPoint(object) {
    const intersects = this.intersectObject([object]);
    return intersects.length > 0 ? intersects[0].point : null;
  }
}

export default Raycaster;
